/* eslint-disable import/named */
import { NuxtAxiosInstance } from 'vue/types/vue';
import { AxiosRequestConfig } from 'axios';
import { ResponseBase } from './base';
import { Feed } from './feed';
import { Picture } from './topic';

export interface DiscoverListRequest {
    searchWord?: string;
    pcursor?: number | string;
    mobile?: boolean;
    fromUser?: boolean;
    count?: number;
    request_source?: number;
    seoDefaultFilterV2?: boolean;
}

export type DiscoverItem = Feed | Picture;

interface DiscoverListResponse extends ResponseBase {
    pcursor?: string | number;
    feeds?: Array<DiscoverItem>;
}

export class DiscoverApiService {
    private $axios?: NuxtAxiosInstance;

    constructor(axios?: NuxtAxiosInstance) {
        this.$axios = axios;
    }

    async getDiscoverList(data: DiscoverListRequest, config?: AxiosRequestConfig) {
        const res = await this.$axios?.$$post?.<DiscoverListResponse>('overseaAPI::/rest/o/w/pwa/discover', data, config);

        return res;
    }
}

export const DiscoverApi = (axios?: NuxtAxiosInstance) => new DiscoverApiService(axios);
